'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../../node_modules/prop-types/index.js');

var index$1 = require('../../../node_modules/classnames/index.js');

var CarouselContext = require('../CarouselContext.js');

var arrow_left_inline = require('../../../assets/svg/arrow_left.inline.svg.js');

var arrow_right_inline = require('../../../assets/svg/arrow_right.inline.svg.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var CarouselControl = function CarouselControl(props) {
  var className = props.className,
      direction = props.direction,
      iconLeft = props.iconLeft,
      iconRight = props.iconRight,
      loop = props.loop,
      onClick = props.onClick,
      stopRight = props.stopRight,
      Tag = props.tag;
  var text;

  if (direction === 'prev') {
    text = 'Previous';
  } else if (direction === 'next') {
    text = 'Next';
  }

  var classes = index$1['default']("lanl-carousel-control-".concat(direction), 'lanl-carousel-controls-btn', className);
  var caretClasses = index$1['default']("lanl-carousel-control-".concat(direction, "-icon"));
  return /*#__PURE__*/React__default['default'].createElement(CarouselContext['default'].Consumer, null, function (_ref) {
    var activeItem = _ref.activeItem,
        length = _ref.length;
    var isDisabled = loop ? false : activeItem === 0 && iconLeft || activeItem === length - stopRight && iconRight;
    return /*#__PURE__*/React__default['default'].createElement(Tag, {
      "data-testid": "lanl-carousel-control",
      className: classes,
      "data-slide": direction,
      onClick: onClick,
      disabled: isDisabled
    }, iconLeft ? /*#__PURE__*/React__default['default'].createElement(arrow_left_inline['default'], {
      title: "Carousel left",
      className: "lanl-controls"
    }) : iconRight ? /*#__PURE__*/React__default['default'].createElement(arrow_right_inline['default'], {
      title: "Carousel right",
      className: "lanl-controls"
    }) : /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("span", {
      className: caretClasses,
      "aria-hidden": "true"
    }), /*#__PURE__*/React__default['default'].createElement("span", {
      className: "sr-only"
    }, text)));
  });
};

CarouselControl.propTypes = {
  className: index['default'].string,
  direction: index['default'].string,
  iconLeft: index['default'].bool,
  iconRight: index['default'].bool,
  loop: index['default'].bool,
  onClick: index['default'].any,
  stopRight: index['default'].number,
  tag: index['default'].oneOfType([index['default'].func, index['default'].string])
};
CarouselControl.defaultProps = {
  tag: 'button'
};
exports.CarouselControl = CarouselControl;
exports['default'] = CarouselControl;